import axios from 'axios'
//import Cookies from 'js-cookie'

export const http = axios.create({
  baseURL: `${process.env.VUE_APP_APIURL}/`,
  // SET TO FALSE WHEN USE TOKEN AUTH VIA SANCTUM
  withCredentials: false
})

http.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest'
  // 'Content-Type': 'application/x-www-form-urlencoded'
  // 'Content-Type': 'multipart/form-data'
}

// ONLY USE TO TOKEN AUTH VIA SANCTUM
/* http.interceptors.request.use(function(config) {
  config.headers.Authorization = `Bearer ${Cookies.get('token')}`
  config.headers['user-guard'] = Cookies.get('guard')

  return config
}) */

export default http
